import { Box, SxProps, Theme } from '@mui/material';
import { Locale, LocalizedString } from '@synergy/models';
import { PropsWithChildren, ReactNode } from 'react';
import { theme } from '@synergy/theme';

import { useAppSelector } from '../../../store/use-appstate-selector';

export interface TranslatedFieldProps {
    selectedLocale: Locale;
    value: LocalizedString;
    fallback?: string;
    sx?: SxProps<Theme>;
    render?: (displayValue: string) => ReactNode;
}

export const TranslatedField = (props: PropsWithChildren<TranslatedFieldProps>) => {
    const currentLocale = useAppSelector(state => state.currentLocale);
    const { value, fallback, sx, selectedLocale, render = value => value } = props;

    const color = value[selectedLocale] ? undefined : theme.palette.grey[700];
    const displayValue = value[selectedLocale] || `${currentLocale.toUpperCase()}: ${value[currentLocale]}` || fallback;

    return displayValue ? <Box sx={{ color, ...sx }}>{render(displayValue)}</Box> : null;
};
